import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsxs("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 24 24', className: className, fill: fillColor, children: [_jsx("path", { d: 'M 3,3 7,3 V 21 H 3 A 1,1 45 0 1 2,20 V 4 A 1,1 135 0 1 3,3 Z' }), _jsx("rect", { width: '6', height: '18', x: '9', y: '3' }), _jsx("path", { d: 'm 17,3 h 4 a 1,1 45 0 1 1,1 v 16 a 1,1 135 0 1 -1,1 h -4 z' })] }));
});
export default React.memo(Icon);
